const modalTitles = ['None', 'View Floorplan', 'Other'].map(title => ({
  id: title,
  name: title
}));

export default modalTitles;
